import React, {useState, useEffect} from 'react';
import Form from 'react-bootstrap/Form';
import Button from "react-bootstrap/Button";
import Select from 'react-select';
import FloatingLabel from 'react-bootstrap/FloatingLabel';

function ReserveStock (){

  const [Customers, SetCustomers] = useState([]);

  useEffect(() => {
    const fetchCustomers = async () => {
      const result = await fetch(import.meta.env.VITE_URL + '/customers.json');
      const jsonresult = await result.json()
      SetCustomers(jsonresult)
    }
    fetchCustomers();
  }, [])


  var Customer_ID = 0;
  const handleCustomerChange = (event) => {
    Customer_ID = event.value;
    SetFilteredSales(Sales.filter(s => s.customer_id == Customer_ID))
  }

  var Sales_ID = 0;
  const handleSalesChange = (event) => {
    Sales_ID = event.value;
  }

  const [Sales, SetSales] = useState([]);

  useEffect(() => {
    const fetchSales = async () => {
      const result = await fetch(import.meta.env.VITE_URL + '/salesleads.json');
      const jsonresult = await result.json()
      SetSales(jsonresult)
    }
    fetchSales();
  }, [])

  const [FilteredSales, SetFilteredSales] = useState([]);

  const [Products, SetProducts] = useState([]);
  const [Product, SetProduct] = useState([]);
  const [Roll, SetRoll] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      const result = await fetch(import.meta.env.VITE_URL + '/products.json');
      const jsonresult = await result.json()
      SetProducts(jsonresult)
    }
    fetchProducts();
  }, [])

  const handleProductChange = (event) => {
    SetProduct(event.value);

    if (event.value.product_type == "Carpet"){
      console.log("Roll");

      SetFilteredStocks(Stocks.filter(s => s.product_id == event.value.id))

    }
    else {
      console.log("Consumable");
    }
    console.log(FilteredRolls);
  }


  const handleStockSelect = (event) => {
    var SetStock = (event.value);
    SetRoll(Rolls.filter(r => r.id == SetStock.stock_type_id))
  }
  console.log(Roll);

  const [Stocks, SetStocks] = useState([]);

  useEffect(() => {
    const fetchStocks = async () => {
      const result = await fetch(import.meta.env.VITE_URL + '/stocks.json');
      const jsonresult = await result.json()
      SetStocks(jsonresult)
    }
    fetchStocks();
  }, []);

  const [FilteredStocks, SetFilteredStocks] = useState([]);
  const [FilteredRolls, SetFilteredRolls] = useState([]);

  const [Rolls, SetRolls] = useState([])
  useEffect(() => {
    const fetchRolls = async () => {
      const result = await fetch(import.meta.env.VITE_URL + '/stocks/stock_rolls.json');
      const jsonresult = await result.json()
      SetRolls(jsonresult)
    }
    fetchRolls();
  }, []);


  var Quantity = 0;
  const handleQuantityChange = (event) => {
    Quantity = event.value;
    console.log(Quantity);
  }

  return (
    <Form>
      <h1>Reserve Stock Form</h1>

      <Form.Text id="d" muted>
        Select the Customer this Stock Reservation belongs to:
          <Select
            options={Customers.map(opt => ({ label: opt.customerdisplayname, value: opt.id }))}
            onChange={event => handleCustomerChange(event)}
          />
      </Form.Text>

      <Form.Text id="d" muted>
        Select the Sales Lead this Stock Reservation belongs to:
          <Select
            options={FilteredSales.map(opt => ({ label: opt.id + " - " + opt.description + " - " + opt.status, value: opt.id }))}
            onChange={event => handleSalesChange(event)}
          />
      </Form.Text>

      <Form.Text id="d" muted>
        Select the Product this Stock Reservation belongs to:
          <Select
            options={Products.map(opt => ({ label: opt.name + " - " + opt.status, value: opt }))}
            onChange={event => handleProductChange(event)}
          />
      </Form.Text>

      <Form.Text id="d" muted>
        Select the availabe Stock this Stock Reservation belongs to:
          <Select
            options={FilteredStocks.map(opt => ({ label: opt.id, value: opt.id }))}
            onChange={event => handleStockSelect(event)}
          />
      </Form.Text>

      <Form.Text id="d" muted>
        Quantity available
        <FloatingLabel id="label" label="Quantity available" className='mb-3'>
          <Form.Control
            type="number"
            id="Quantity_Available"
            min="0.01"
            step="0.01"
            value={Roll}
            readOnly
          />
        </FloatingLabel>
      </Form.Text>

      <Form.Text id="d" muted>
        Enter the Quantity to reserve.
        <FloatingLabel id="label" label="Quantity to Reserve" className='mb-3'>
          <Form.Control
            type="number"
            id="Quantity"
            min="0.01"
            step="0.01"
            onChange={handleQuantityChange}
          />
        </FloatingLabel>
      </Form.Text>


      <br></br>
      <Button type="submit">Submit Form</Button>
    </Form>
  );
}

export default ReserveStock;
